import { SearchOutlined } from '@ant-design/icons';
import { Select, Modal, Input as inputAntd, Button, Spin, Row } from 'antd';
import { billingSelectors, workSpaceSelectors } from 'containers/App/selectors';
import { Formik, FormikHelpers } from 'formik';
import { Form, Input, SubmitButton } from 'formik-antd';
import { setLoadStep2 } from 'pages/BillingProcess/slices';
import {
  deletePastHospital,
  DetailCheck,
  getCPAPByFacility,
  getHospitalStep2,
  checkHospitalAdd,
  getPastHospital,
  pageHospitalStep2,
} from 'pages/BillingProcess/thunk';
import React, { FC, useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Pagination } from 'components';
import { t_hospital_visit, t_medical_institution } from 'types';
import TableCreate from './TableCreate';
import TableDetail from './TableDetail';
import TableModal from './TableModal';
import { Wrapper } from './styles';

type Props = {
  nextStep: () => void;
  stepToPrevious: () => void;
};

type InitialValues = {
  cpap_id: string;
  add_year: string;
  add_month: string;
  hospital_visit_remark: string;
};

const newDate = new Date();
const addYear = newDate.getFullYear();

const optionTartgetMonth = {
  year: [(addYear - 1).toString(), addYear.toString(), (addYear + 1).toString()],
  month: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
};

const BillingSecondStep: FC<Props> = ({ nextStep, stepToPrevious }) => {
  const dispatch = useDispatch();
  const location = useLocation<{ medicalDetail: t_medical_institution }>();
  const { hospitalsD5, pastHospital, itemInvoice, cpapList, loadStep2, billHospital } = useSelector(billingSelectors);
  const { statusBill } = useSelector(workSpaceSelectors);
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [valueMonth, setValueMonth] = useState('');
  const [year, setYear] = useState('');
  const [page, setPage] = useState<number>(1);
  const [cpap, setCpap] = useState<{
    cpap_id: string;
    patient_name: string;
    patient_id: string;
    i_id: string;
    sp_price: string;
    sort_num: number;
  }>({
    cpap_id: '',
    patient_name: '',
    patient_id: '',
    i_id: '',
    sp_price: '',
    sort_num: 0,
  });
  const [searchCPAP, setSearchCPAP] = useState('');
  const [remark, setRemark] = useState<string>('');
  const [errorAdd, setErrorAdd] = useState('');

  useEffect(() => {
    dispatch(setLoadStep2(true));
    dispatch(
      getHospitalStep2({
        facility_id: location.state.medicalDetail.i_id ?? '',
        facility_name: location.state.medicalDetail.facility_name ?? '',
        invoice_month: itemInvoice?.invoice_month ?? '',
        invoice_id: itemInvoice?.i_id ?? '',
        statusBill: statusBill && statusBill.value === itemInvoice?.invoice_month ? '確定' : '',
      }),
    );
    dispatch(getCPAPByFacility({ facility_id: location.state.medicalDetail.i_id ?? '' }));
    dispatch(
      getPastHospital({
        facility_id: location.state.medicalDetail.i_id ?? '',
        invoice_month: itemInvoice?.invoice_month ?? '',
      }),
    );
  }, [dispatch, location.state, itemInvoice, statusBill]);

  const onChangePage = (page: number) => {
    setPage(page);
    dispatch(
      pageHospitalStep2({
        facility_id: location.state.medicalDetail.i_id ?? '',
        facility_name: location.state.medicalDetail.facility_name ?? '',
        invoice_month: itemInvoice?.invoice_month ?? '',
        page: page,
      }),
    );
  };

  const handleSearchCPAP = (value: string) => {
    setSearchCPAP(value);
    dispatch(getCPAPByFacility({ facility_id: location.state.medicalDetail.i_id ?? '', searchValue: value }));
  };

  const { Search } = inputAntd;
  const handleSubmit = async (value: InitialValues, form: FormikHelpers<InitialValues>) => {
    try {
      dispatch(setLoadStep2(true));
      let dataSubmit = null;
      if (billHospital === 1 || Number(`${year}${valueMonth}`) === Number(itemInvoice?.invoice_month)) {
        setErrorAdd('指定の月は追加できません');
        return;
      }
      if (billHospital === 0) {
        const billType =
          Number(`${year}${valueMonth}`) > Number(itemInvoice?.invoice_month) ? 'o_advance_payment' : 'o_recovery';
        dataSubmit = {
          target_month: `${year}${valueMonth}`,
          hospital_visit_remark: remark,
          invoice_month: itemInvoice?.invoice_month ?? '',
          facility_id: location.state.medicalDetail.i_id ?? '',
          cpap_id: cpap.i_id,
          hospital_visit: 'o_no',
          billing_type: billType,
          target_month_num: Number(year.concat(valueMonth)),
          patient_id: cpap.patient_id,
          sp_price: cpap.sp_price,
          csv_key: `${year}${valueMonth}_${cpap.i_id}`,
          sort_num: cpap.sort_num || 99999,
        };
      }
      if (billHospital && typeof billHospital === 'object') {
        if (billHospital.facility_id !== itemInvoice?.facility_id) {
          setErrorAdd('ご指定月時点の医療機関が違うため追加できません');
          return;
        }
        if (
          Number(`${year}${valueMonth}`) > Number(itemInvoice?.invoice_month) &&
          billHospital.billing_type === '先払い'
        ) {
          setErrorAdd('指定の月は追加できません');
          return;
        }
        const billType =
          Number(`${year}${valueMonth}`) > Number(itemInvoice?.invoice_month) ? 'o_advance_payment' : 'o_recovery';
        dataSubmit = {
          i_id: billHospital.i_id,
          billing_type: billType,
          invoice_month: itemInvoice?.invoice_month ?? '',
          hospital_visit_remark: remark,
          sort_num: cpap.sort_num || 99999,
        };
      }
      const result: any = await dispatch(DetailCheck(dataSubmit));
      if (result) {
        await new Promise((resolve) =>
          setTimeout(() => {
            resolve(
              dispatch(
                getPastHospital({
                  facility_id: location.state.medicalDetail.i_id ?? '',
                  invoice_month: itemInvoice?.invoice_month ?? '',
                }),
              ),
            );
          }, 1000),
        );
      }
      form.setSubmitting(false);
      form.resetForm();
      setCpap({
        cpap_id: '',
        patient_name: '',
        patient_id: '',
        i_id: '',
        sp_price: '',
        sort_num: 0,
      });
      setSearchCPAP('');
      setRemark('');
      setYear('');
      setValueMonth('');
    } finally {
      dispatch(setLoadStep2(false));
    }
  };

  const UpdatePastHospital = async (data: t_hospital_visit) => {
    dispatch(setLoadStep2(true));
    await dispatch(deletePastHospital(data));
    await new Promise((resolve) =>
      setTimeout(() => {
        resolve(
          dispatch(
            getPastHospital({
              facility_id: location.state.medicalDetail.i_id ?? '',
              invoice_month: itemInvoice?.invoice_month ?? '',
            }),
          ),
        );
      }, 1000),
    );
    dispatch(setLoadStep2(false));
  };

  return (
    <Spin spinning={loadStep2} size="large">
      <Wrapper>
        <div className="section">
          <div className="info-step">
            <div className="extraLargeFont">2. CPAP利用明細作成</div>
            <div className="smallFont">最大請求月数：{location.state.medicalDetail.billable_month ?? 0}ヶ月分</div>
          </div>
          <div className="table-create">
            <TableCreate data={hospitalsD5?.items ?? []} page={page} />
          </div>
          <div style={{ marginTop: '20px' }}>
            <Pagination page={page} onChangePage={onChangePage} totalItems={hospitalsD5?.totalItems} per_page={50} />
          </div>
          <div className="info-detail-bill extraLargeFont">この請求月に追加する明細</div>
          <div className="table-create">
            <TableDetail
              data={pastHospital}
              handleDelete={UpdatePastHospital}
              statusBill={statusBill && statusBill.value === itemInvoice?.invoice_month}
            />
          </div>
          {statusBill && statusBill.value === itemInvoice?.invoice_month ? null : (
            <div className="add-statement">
              <div className="standardBoldFont text">明細を追加</div>
              <div>
                <Formik
                  onSubmit={handleSubmit}
                  initialValues={initialValues}
                  render={() => (
                    <Form layout="inline" className="form-add">
                      <Form.Item name="cpap_id">
                        <p className=" label-select standardBoldFont">利用者名</p>
                        <Search
                          className="read-only"
                          size="large"
                          onSearch={(value) => {
                            setModalVisible(true);
                          }}
                          value={cpap.patient_name}
                          name="cpap_id"
                          enterButton="選択"
                        />

                        <Modal
                          title="利用者選択"
                          centered
                          closable={false}
                          visible={modalVisible}
                          onOk={async () => {
                            setModalVisible(false);
                            if (year && valueMonth) {
                              setErrorAdd('');
                              dispatch(setLoadStep2(true));
                              const res: any = await dispatch(
                                checkHospitalAdd({
                                  cpap_id: cpap.i_id,
                                  year: year,
                                  month: valueMonth,
                                  invoiceMonth: itemInvoice?.invoice_month,
                                }),
                              );
                              if (res.payload && typeof res.payload === 'object') {
                                setRemark(res.payload.hospital_visit_remark);
                              } else {
                                setRemark('');
                              }
                              dispatch(setLoadStep2(false));
                            }
                          }}
                          onCancel={() => {
                            setModalVisible(false);
                            setSearchCPAP('');
                            setCpap({
                              cpap_id: '',
                              patient_name: '',
                              patient_id: '',
                              i_id: '',
                              sp_price: '',
                              sort_num: 0,
                            });
                          }}
                          okButtonProps={{
                            disabled: !cpap.cpap_id,
                          }}
                          okText="選択"
                          cancelText="キャンセル"
                          width={820}
                          bodyStyle={{
                            backgroundColor: '#eeeeee',
                            paddingBottom: '40px',
                          }}
                        >
                          <p style={{ textAlign: 'center' }} className="standardBoldFont">
                            患者を選択し「選択」ボタンをクリックしてください。
                          </p>
                          <Input
                            style={{
                              border: '1px solid #777777',
                              width: '576px',
                              height: '39px',
                              borderRadius: '19.5px',
                              margin: '0px 0px 28px 100px',
                            }}
                            prefix={<SearchOutlined />}
                            allowClear
                            placeholder="検索"
                            size={'large'}
                            value={searchCPAP}
                            onChange={(e) => handleSearchCPAP(e.target.value)}
                            className="standardBoldFont"
                            name="add_user"
                          />
                          <TableModal data={cpapList ?? []} cpapCheck={cpap} handleCheck={setCpap} />
                        </Modal>
                      </Form.Item>
                      <Form.Item name="add-year">
                        <p className="label-select standardBoldFont">対象年月</p>
                        <Select
                          id="year"
                          disabled={!cpap.cpap_id}
                          size={'large'}
                          style={{ width: 100 }}
                          placeholder="選択"
                          value={year}
                          onChange={(e: any) => setYear(e)}
                        >
                          {optionTartgetMonth.year.map((v) => v && <Select.Option value={v}>{v}</Select.Option>)}
                        </Select>
                        <label htmlFor="year"> 年</label>
                      </Form.Item>
                      <Form.Item name="add-month">
                        <Select
                          id="month"
                          disabled={!cpap.cpap_id}
                          size={'large'}
                          style={{ width: 100, marginTop: 22 }}
                          placeholder="選択"
                          value={valueMonth}
                          onChange={async (e: any) => {
                            setValueMonth(e);
                            setErrorAdd('');
                            dispatch(setLoadStep2(true));
                            const res: any = await dispatch(
                              checkHospitalAdd({
                                cpap_id: cpap.i_id,
                                year: year,
                                month: e,
                                invoiceMonth: itemInvoice?.invoice_month,
                              }),
                            );
                            if (res.payload && typeof res.payload === 'object') {
                              setRemark(res.payload.hospital_visit_remark);
                            } else {
                              setRemark('');
                            }
                            dispatch(setLoadStep2(false));
                          }}
                        >
                          {optionTartgetMonth.month.map((v) => v && <Select.Option value={v}>{v}</Select.Option>)}
                        </Select>
                        <label htmlFor="month"> 月</label>
                      </Form.Item>
                      <Form.Item name="hospital_visit_remark">
                        <p className="label-select standardBoldFont">備考</p>
                        <Input
                          value={remark}
                          onChange={(e) => setRemark(e.target.value)}
                          style={{ maxWidth: 460 }}
                          size="large"
                          name="hospital_visit_remark"
                        />
                      </Form.Item>
                      <SubmitButton
                        size={'large'}
                        className="btn-sbm btn-add"
                        disabled={!cpap.patient_name || !year || !valueMonth || loadStep2}
                      >
                        追加
                      </SubmitButton>
                    </Form>
                  )}
                />
                <Row className="error">{errorAdd}</Row>
              </div>
            </div>
          )}
          <div className="standardBoldFont confirm-create-bill">
            以上の内容で請求書を作成します。よろしければ「次へ」をクリックしてください。
          </div>
          <div className="confirm-step">
            <Button onClick={stepToPrevious} className="btn-cancel-save">
              戻る
            </Button>
            <Button onClick={() => nextStep()} className="btn-save">
              {statusBill && statusBill.value === itemInvoice?.invoice_month ? '次へ' : '保存して次へ'}
            </Button>
          </div>
        </div>
      </Wrapper>
    </Spin>
  );
};

const initialValues: InitialValues = {
  cpap_id: '',
  add_year: '',
  add_month: '',
  hospital_visit_remark: '',
};

export default BillingSecondStep;
